import React, { useMemo, useState } from 'react';

import { Divider } from '@cube3/ui/src/Surface/Divider';
import { Typography } from '@cube3/ui/src/typography/Typography';
import { Field } from 'redux-form';
import { WrappedSuggestionPicker } from '../../../../Contracts/prefabs/MultipleResourcePicker/SuggestionsPickerBase';
import { Team } from '@cube3/common/model/schema/resources/team';

export const WorkspaceTeamsPicker = ({
  form,
  workspaceTeams,
  loading = false
}: {
  form: string;
  workspaceTeams: Team[];
  loading?: boolean;
}) => {
  const [query, setQuery] = useState('');

  const suggestedTeams = useMemo(() => {
    if (!query) return workspaceTeams;
    return workspaceTeams.filter((team) =>
      team.display_name.toLowerCase().includes(query.toLowerCase())
    );
  }, [workspaceTeams, query]);

  return (
    <div style={{ margin: '25px 0' }}>
      <Divider />
      <div style={{ height: 25 }}></div>
      <Typography color="contrast2" typographyStyle="body2">
        Add to teams...
      </Typography>
      <div style={{ height: 8 }}></div>
      <Field
        name="teams"
        component={WrappedSuggestionPicker}
        props={{
          form,
          query,
          setQuery,
          suggestions: suggestedTeams,
          autoFocus: false,
          placeholder: 'Enter a team name',
          primaryKey: 'display_name',
          allowAddingOfNewSuggestions: false,
          loading: loading
        }}
      />
    </div>
  );
};
